import type { PessoaDetalhe } from "@/api/contrato";
import { useAlterarPessoa } from "@/api/consultas";
import { useAvisos } from "@/componentes/Avisos";
import { ModalDeCadastro } from "@/componentes/ModalDeCadastro";
import { useSessao } from "@/sessao/useSessao";
import { validarEdicao, valoresDe } from "./cedente-formulario";
import { FormularioDeCedente, useFormularioDeCedente } from "./FormularioDeCedente";

/*
 * Edição do cedente, com o formulário da criação. Quem a monta é a aba Dados, por
 * `?abrir=editar`, conferindo o papel antes: a URL qualquer um cola.
 *
 * O documento fica só leitura, e a API recusa `documento` no `PATCH` do mesmo jeito.
 * Situação não passa por aqui: é o interruptor, que exige motivo.
 */
export function EditarCedente({
  pessoa,
  aoFechar,
}: {
  pessoa: PessoaDetalhe;
  aoFechar: () => void;
}) {
  const { cliente } = useSessao();
  const avisos = useAvisos();
  const alterar = useAlterarPessoa(cliente, pessoa.id);
  const formulario = useFormularioDeCedente(valoresDe(pessoa));

  function enviar() {
    const corpo = formulario.conferir(validarEdicao(formulario.valores, pessoa));
    if (corpo === null) return;

    // `PATCH` sem chave é `400 invalid_body`: sem mudança, não há o que pedir.
    if (Object.keys(corpo).length === 0) {
      aoFechar();
      return;
    }

    alterar.mutate(corpo, {
      onSuccess: () => {
        avisos.feito("Cedente alterado");
        aoFechar();
      },
      onError: formulario.recusar,
    });
  }

  return (
    <ModalDeCadastro
      aberto
      aoFechar={aoFechar}
      titulo="Editar cedente"
      descricao={pessoa.razao_social}
      aoEnviar={enviar}
      enviando={alterar.isPending}
      erro={formulario.erroGeral}
      rotuloDeEnvio="Salvar"
    >
      <FormularioDeCedente formulario={formulario} documentoFixo />
    </ModalDeCadastro>
  );
}
